import React from "react";
import {
    Button
} from "react-bootstrap";
import PropTypes from "prop-types";
import moment from "moment";

import RadioChip from "../../../components/RadioChip";

function DiscountCodeForm({ state, originalState, onChange, loading, onSave, formType }) {
    const type = state.type || state.discountCodeType;
    const discountMode = state.enableDiscountValue ? "value" : "percentage";

    return (
        <React.Fragment>
            <div className="card mb-3">
                <div className="card-body">
                    <h4>Kortingscode</h4>
                    <div className="form-group mb-0">
                        <label htmlFor="code">Code</label>
                        <input
                            type="text"
                            className="form-control"
                            id="code"
                            value={ state.code }
                            onChange={ (event) => onChange({ code: event.target.value }) }
                            disabled={ loading }
                        />
                    </div>
                </div>
            </div>

            <div className="card mb-3">
                <div className="card-body">
                    <h4>Korting</h4>
                    <div className="mb-3">
                        <RadioChip
                            checked={ discountMode === "value" }
                            onClick={ () => onChange({ enableDiscountValue: true, enableDiscountPercentage: false, discountPercentage: "" }) }
                            className="mr-2"
                            disabled={ loading }
                        >
                            Vast bedrag
                        </RadioChip>
                        <RadioChip
                            checked={ discountMode === "percentage" }
                            onClick={ () => onChange({ enableDiscountPercentage: true, enableDiscountValue: false, discountValue: "" }) }
                            disabled={ loading }
                        >
                            Percentage
                        </RadioChip>
                    </div>
                    { discountMode === "value" && (
                        <div className="form-group mb-0">
                            <label htmlFor="discountValue">Kortingsbedrag (Euro &euro;)</label>
                            <input
                                type="number"
                                className="form-control"
                                id="discountValue"
                                value={ state.discountValue }
                                onChange={ (event) => onChange({ discountValue: event.target.value }) }
                                disabled={ loading }
                                step="0.01"
                                min="0"
                            />
                        </div>
                    )}
                    { discountMode === "percentage" && (
                        <div className="form-group mb-0">
                            <label htmlFor="discountPercentage">Kortingspercentage (%)</label>
                            <input
                                type="number"
                                className="form-control"
                                id="discountPercentage"
                                value={ state.discountPercentage != null && state.discountPercentage !== "" ? state.discountPercentage * 100 : "" }
                                onChange={ (event) => onChange({ discountPercentage: event.target.value !== "" ? parseFloat(event.target.value) / 100 : "" }) }
                                disabled={ loading }
                                step="1"
                                min="0"
                                max="100"
                            />
                        </div>
                    )}
                </div>
            </div>

            <div className="card mb-3">
                <div className="card-body">
                    <h4>Gebruik</h4>
                    { type === "voucher" ? (
                        <p className="text-muted mb-0">Vouchers zijn eenmalig te gebruiken.</p>
                    ) : (
                        <React.Fragment>
                            <div className="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="enableMaxUsageCount"
                                    checked={ state.enableMaxUsageCount }
                                    onChange={ (event) => onChange({ enableMaxUsageCount: event.target.checked }) }
                                    disabled={ loading }
                                />
                                <label htmlFor="enableMaxUsageCount" className="custom-control-label">Maximaal aantal keer te gebruiken</label>
                            </div>
                            { state.enableMaxUsageCount && (
                                <div className="form-group mb-0 mt-2 ml-4">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="maxUsageCount"
                                        placeholder="Maximaal aantal"
                                        value={ state.maxUsageCount }
                                        onChange={ (event) => onChange({ maxUsageCount: event.target.value }) }
                                        disabled={ loading }
                                        min="1"
                                    />
                                    <small className="form-text text-muted">
                                        Maximaal aantal keer dat deze code gebruikt kan worden
                                    </small>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                    <div className="custom-control custom-checkbox mt-3">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="combinable"
                            checked={ state.combinable }
                            onChange={ (event) => onChange({ combinable: event.target.checked }) }
                            disabled={ loading }
                        />
                        <label htmlFor="combinable" className="custom-control-label">Combineerbaar met andere kortingscodes</label>
                        <small className="form-text text-muted">
                            Als dit uit staat kan deze code niet samen met een andere kortingscode gebruikt worden
                        </small>
                    </div>
                </div>
            </div>

            <div className="card mb-3">
                <div className="card-body">
                    <h4>Geldigheidsperiode</h4>
                    <div className={ "custom-control custom-checkbox" + (state.enableStartDate ? " mb-2" : "") }>
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enableStartDate"
                            checked={ state.enableStartDate }
                            onChange={ (event) => {
                                if(event.target.checked) {
                                    if(originalState?.startDate) {
                                        onChange({ enableStartDate: true, startDate: originalState.startDate });
                                    } else {
                                        onChange({ enableStartDate: true, startDate: moment().format("YYYY-MM-DD HH:mm:ss") });
                                    }
                                } else {
                                    onChange({ enableStartDate: false, startDate: null });
                                }
                            } }
                            disabled={ loading }
                        />
                        <label htmlFor="enableStartDate" className="custom-control-label">Startdatum instellen</label>
                    </div>
                    { state.enableStartDate && (
                        <div className="form-group mb-3 ml-4">
                            <input
                                type="datetime-local"
                                className="form-control"
                                id="startDate"
                                value={ moment(state.startDate).format("YYYY-MM-DDTHH:mm") }
                                onChange={ (event) => onChange({ startDate: moment(event.target.value).format("YYYY-MM-DD HH:mm:ss") }) }
                                disabled={ loading }
                            />
                        </div>
                    )}
                    <div className={ "custom-control custom-checkbox" + (state.enableExpirationDate ? " mb-2" : "") }>
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enableExpirationDate"
                            checked={ state.enableExpirationDate }
                            onChange={ (event) => {
                                if(event.target.checked) {
                                    if(originalState?.expirationDate) {
                                        onChange({ enableExpirationDate: true, expirationDate: originalState.expirationDate });
                                    } else {
                                        onChange({ enableExpirationDate: true, expirationDate: moment().format("YYYY-MM-DD HH:mm:ss") });
                                    }
                                } else {
                                    onChange({ enableExpirationDate: false, expirationDate: null });
                                }
                            } }
                            disabled={ loading }
                        />
                        <label htmlFor="enableExpirationDate" className="custom-control-label">Verloopdatum instellen</label>
                    </div>
                    { state.enableExpirationDate && (
                        <div className="form-group mb-0 ml-4">
                            <input
                                type="datetime-local"
                                className="form-control"
                                id="expirationDate"
                                value={ moment(state.expirationDate).format("YYYY-MM-DDTHH:mm") }
                                onChange={ (event) => onChange({ expirationDate: moment(event.target.value).format("YYYY-MM-DD HH:mm:ss") }) }
                                disabled={ loading }
                            />
                        </div>
                    )}
                </div>
            </div>

            { formType === "edit" && (
                <div className="card mb-3">
                    <div className="card-body">
                        <h4>Status</h4>
                        <div className="custom-control custom-checkbox mb-0">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="enabled"
                                checked={ state.enabled }
                                onChange={ (event) => onChange({ enabled: event.target.checked }) }
                                disabled={ loading }
                            />
                            <label htmlFor="enabled" className="custom-control-label">Ingeschakeld</label>
                        </div>
                    </div>
                </div>
            )}

            <Button
                variant="primary"
                className="float-right"
                onClick={ onSave }
                disabled={ loading }
            >
                Opslaan
            </Button>
        </React.Fragment>
    )
}
DiscountCodeForm.propTypes = {
    state: PropTypes.object,
    originalState: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    formType: PropTypes.oneOf(["new", "edit"]).isRequired,
}

export default React.memo(DiscountCodeForm);
